<template>
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3474 5.64036L13.3473 5.64041L13.3534 5.64655L17.3534 9.6465C17.3534 9.64652 17.3534 9.64654 17.3534 9.64655C17.4471 9.74031 17.4998 9.86744 17.4998 10C17.4998 10.1326 17.4471 10.2597 17.3534 10.3534C17.3534 10.3535 17.3534 10.3535 17.3534 10.3535L13.3534 14.3534L13.3534 14.3534L13.3474 14.3596C13.3012 14.4074 13.2461 14.4455 13.1851 14.4717C13.1241 14.4979 13.0584 14.5117 12.9921 14.5123C12.9257 14.5128 12.8598 14.5002 12.7984 14.4751C12.7369 14.4499 12.6811 14.4128 12.6342 14.3658C12.5872 14.3189 12.5501 14.2631 12.5249 14.2016C12.4998 14.1402 12.4872 14.0743 12.4877 14.0079C12.4883 13.9416 12.5021 13.8759 12.5283 13.8149C12.5545 13.7539 12.5926 13.6988 12.6404 13.6526L12.6404 13.6527L12.6466 13.6466L14.9396 11.3536L15.7931 10.5H14.586H7C6.86739 10.5 6.74022 10.4473 6.64645 10.3536C6.55268 10.2598 6.5 10.1326 6.5 10C6.5 9.86739 6.55268 9.74022 6.64645 9.64645C6.74022 9.55268 6.86739 9.5 7 9.5H14.586H15.7931L14.9396 8.64645L12.6466 6.35345L12.6466 6.35339L12.6404 6.34736C12.5926 6.30123 12.5545 6.24606 12.5283 6.18506C12.5021 6.12406 12.4883 6.05845 12.4877 5.99206C12.4872 5.92567 12.4998 5.85983 12.5249 5.79838C12.5501 5.73693 12.5872 5.6811 12.6342 5.63416C12.6811 5.58721 12.7369 5.55009 12.7984 5.52494C12.8598 5.4998 12.9257 5.48715 12.9921 5.48773C13.0584 5.48831 13.1241 5.5021 13.1851 5.5283C13.2461 5.55451 13.3012 5.5926 13.3474 5.64036ZM9.5 19C9.5 19.1326 9.44732 19.2598 9.35355 19.3536C9.25979 19.4473 9.13261 19.5 9 19.5H5.0006C3.8074 19.4986 2.66349 19.0239 1.81977 18.1802C0.976125 17.3366 0.501506 16.1928 0.5 14.9997V5.00031C0.501506 3.80722 0.976125 2.66342 1.81977 1.81977C2.66342 0.976125 3.80722 0.501506 5.00031 0.5H9C9.13261 0.5 9.25978 0.552678 9.35355 0.646446C9.44732 0.740215 9.5 0.867392 9.5 1C9.5 1.13261 9.44732 1.25979 9.35355 1.35355C9.25978 1.44732 9.13261 1.5 9 1.5H5C4.07174 1.5 3.1815 1.86875 2.52513 2.52513C1.86875 3.1815 1.5 4.07174 1.5 5V15C1.5 15.9283 1.86875 16.8185 2.52513 17.4749C3.1815 18.1313 4.07174 18.5 5 18.5H9C9.13261 18.5 9.25979 18.5527 9.35355 18.6464C9.44732 18.7402 9.5 18.8674 9.5 19Z"
      fill="url(#paint0_linear_1_2565)"
      stroke="url(#paint1_linear_1_2565)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_2565"
        x1="8.99989"
        y1="0"
        x2="8.99989"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_2565"
        x1="8.99989"
        y1="0"
        x2="8.99989"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
